var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBadgeUsage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 250,
    viewBox: "0 0 500 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2011_60810)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "#2D2F35"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 226,
    y: 52,
    width: 100,
    height: 21,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 226,
    y: 199,
    width: 100,
    height: 21,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 226,
    y: 34,
    width: 18,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 250,
    y: 34,
    width: 48,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 302,
    y: 34,
    width: 27,
    height: 8,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 226,
    y: 83,
    width: 176,
    height: 14,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 226,
    y: 230,
    width: 176,
    height: 14,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 29,
    y: 25,
    width: 176,
    height: 121,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.05,
    x: 29,
    y: 163,
    width: 176,
    height: 87,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.2,
    x: 29,
    y: 140,
    width: 176,
    height: 6,
    rx: 3,
    fill: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.8,
    x: 29,
    y: 140,
    width: 63.1172,
    height: 6,
    rx: 3,
    fill: "#CCCCCC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2011_60810"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 500,
    height: 250,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeUsage);
export default __webpack_public_path__ + "static/media/badge-usage.b3b7a92c9e59a315d6fd17e9ca57c29d.svg";
export { ForwardRef as ReactComponent };